"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var Skiing = function Skiing(_ref) {
  var name = _ref.name,
    fill = _ref.fill,
    className = _ref.className,
    title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    className: "icon ".concat(className, " d8-svg-").concat(name),
    width: "22px",
    height: "25px",
    viewBox: "0 0 22 25",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title || name), /*#__PURE__*/_react["default"].createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(-259.000000, -5522.000000)",
    stroke: fill,
    strokeWidth: "1.5"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(260.000000, 5523.000000)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.7484848,2.8030303 C10.7484848,3.75032545 11.2538607,4.62566227 12.0742424,5.09930985 C12.8946241,5.57295743 13.9053759,5.57295743 14.7257576,5.09930985 C15.5461393,4.62566227 16.0515152,3.75032545 16.0515152,2.8030303 C16.0515152,1.85573516 15.5461393,0.980398337 14.7257576,0.506750757 C13.9053759,0.0331031775 12.8946241,0.0331031775 12.0742424,0.506750757 C11.2538607,0.980398337 10.7484848,1.85573516 10.7484848,2.8030303 L10.7484848,2.8030303 Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.9171717,19.0979798 L14.4727273,15.7272727 C14.0482831,14.7381106 13.2865842,13.931669 12.3232323,13.4515152 L10.0484848,12.3141414 L11.1292929,9.7979798 L17.2727273,12.8707071 C18.0213799,13.2447545 18.9315081,12.9410769 19.3055555,12.1924242 C19.6796029,11.4437716 19.3759254,10.5336434 18.6272727,10.159596 L11.0515152,6.37171717 C10.8410429,6.26662184 10.6089896,6.21198038 10.3737374,6.21212121 L7.28080808,6.21212121 C6.8201548,6.21310967 6.38438154,6.003224 6.0979798,5.64242424 L3.97676768,2.99292929 C3.64903268,2.53943204 3.09804289,2.30346905 2.54366487,2.37919881 C1.98928685,2.45492857 1.52176937,2.83002281 1.32767027,3.35480422 C1.13357118,3.87958563 1.2444884,4.46862354 1.61616162,4.88686869 L3.73737374,7.53636364 C4.59627532,8.61599717 5.90120051,9.24428071 7.28080808,9.24242424 L8.07272727,9.24242424 L6.70505051,12.4343434 C6.6233795,12.6223933 6.58142582,12.8252841 6.58181818,13.030303 L6.58181818,14.8060606 C6.58107073,15.2074915 6.4216794,15.5923544 6.13838384,15.8767677 L5.12828283,16.8868687"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8.28282828,18.0191919 C8.97280514,17.3248684 9.41751265,16.4244598 9.54949495,15.4545455 L10.9737374,16.1616162 C11.293805,16.3221674 11.5470287,16.5904128 11.6888889,16.9191919 L12.4636364,18.7282828"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19.7454545,21.7171717 C19.6609468,22.1100478 19.4238238,22.453259 19.0862546,22.6712961 C18.7486854,22.8893332 18.3383245,22.9643341 17.9454545,22.879798 L1.65151515,19.3757576 C1.25863908,19.2912498 0.915427908,19.0541269 0.697390776,18.7165577 C0.479353643,18.3789884 0.404352753,17.9686275 0.488888889,17.5757576"
  })))));
};
Skiing.propTypes = {
  name: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  fill: _propTypes["default"].string,
  className: _propTypes["default"].string
};
Skiing.defaultProps = {
  fill: '#ffffff',
  className: ''
};
var _default = exports["default"] = Skiing;